export default __webpack_public_path__ + "static/media/Believer's Belt of the Eldritch.0a3cfd96.jpg";